import { render, staticRenderFns } from "./YtVideo.vue?vue&type=template&id=2722cbe2"
import script from "./YtVideo.vue?vue&type=script&lang=ts"
export * from "./YtVideo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports